import React from "react";
import Dialog from "../../components/Dialog/Dialog";
import CloseIcon from "../../components/Icon/Close";
import { withStyles } from "@material-ui/core";
import Button from "../../components/Button/Button";
import CircleInfoIcon from "../../components/Icon/CircleInfoIcon";

const ModalEvolucaoProntuario = ({ classes, open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.paper }}>
      <div className={classes.wrapper}>
        <div className={classes.header}>
          <div className={classes.iconWrap}>
            <CircleInfoIcon size={30} color={"#fff"} />
          </div>

          <Button
            onClick={onClose}
            classes={{ root: classes.closeButton }}
            className={classes.closeButton}
          >
            <CloseIcon />
          </Button>
        </div>

        <div className={classes.content}>
          <h2 className={classes.title}>Não foi possível finalizar!</h2>

          <p className={classes.description}>
            Notamos que você não evoluiu o prontuário, é necessário que você
            <br />
            <strong className={classes.strong}>
              envie pelo menos uma mensagem antes de encerrar o atendimento!
            </strong>
          </p>
        </div>
      </div>
    </Dialog>
  );
};

const styles = {
  paper: {
    borderRadius: "10px",
    overflow: "hidden",
    padding: "20px",
    maxWidth: "327px",
  },

  wrapper: {
    width: "100%",
    background: "#fff",
  },

  header: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
  },

  iconWrap: {
    display: "flex",
    background: "#FB7676",
    borderRadius: "100%",
    justifyContent: "center",
    width: "40px",
    height: "40px",
    alignItems: "center",
  },

  closeButton: {
    minWidth: "unset",
    width: 36,
    height: 36,
    padding: 0,
    borderRadius: "100%",
    background: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#111827",

    "&:hover": {
      background: "rgba(17,24,39,0.06)",
    },
  },

  content: {
    marginTop: 10,
  },

  title: {
    margin: 0,
    fontSize: 18,
    fontWeight: 800,
    color: "#505050",
  },

  description: {
    margin: "8px 0 0 0",
    fontSize: 14,
    lineHeight: 1.45,
    color: "#6b7280",
  },

  strong: {
    color: "#505050",
    fontWeight: 700,
  },

  footer: {
    marginTop: 16,
    display: "flex",
    justifyContent: "flex-end",
  },

  primaryButton: {
    borderRadius: 10,
    padding: "10px 14px",
  },
};

export default withStyles(styles)(ModalEvolucaoProntuario);
